<template>
  <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
    <el-breadcrumb-item class="breadcrumb-item" :to="path">{{ name }}</el-breadcrumb-item>
    <el-breadcrumb-item class="breadcrumb-item" :to="childPath">{{ childName }}</el-breadcrumb-item>
    <el-breadcrumb-item v-if="childPathThree" class="breadcrumb-item" :to="childPathThree">{{ childNameThree }}</el-breadcrumb-item>
  </el-breadcrumb>

<!--  <el-breadcrumb separator="/">-->
<!--    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--    <el-breadcrumb-item v-for="(item, index) in breadList" :key="index">-->
<!--      <span-->
<!--          v-if="item.redirect === 'noRedirect' || index == breadList.length-1"-->
<!--      >{{ item.meta.title }}</span>-->
<!--      <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>-->
<!--    </el-breadcrumb-item>-->
<!--  </el-breadcrumb>-->
</template>

<script>
export default {
  name: "index",
  props: {
    name: String,
    path: String,
    childPath: String,
    childName: String,
    childPathThree: String,
    childNameThree: String
  },
  data() {
    return {
      breadList: []
    }
  },
  created() {
    // console.log(this.$route.matched)
  }

}
</script>

<style scoped >
.breadcrumb {
  font-size: 16px;
  margin: 32px 24px 32px;

}
/deep/.el-breadcrumb  {
  /*margin: 10px;*/
  line-height: 10px !important;
}

@media screen and (max-width: 1200px) {
  .breadcrumb-item {
    font-size: 16px;
  }
}
@media screen and (max-width: 992px) {
  .breadcrumb-item {
    font-size: 16px;
  }
}
@media screen and (max-width: 576px) {
  .breadcrumb-item {
    font-size: 16px;
  }
}
</style>